export const log = (tag, ...params) => {
  if (process.env.NODE_ENV==='development') {
    console.log(tag, params)
  }
}
